<template>
    <v-row>
      <v-col cols="12">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
            class="m-5"
            ref="form"
            lazy-validation
          >
           <v-select
              :disabled="user.type == 'supervisor'"
              :items="typeuser"
              label="Crear cuenta de usuario"
              outlined
              v-model="status_user"
            ></v-select>
            
          
              <div v-if="status_user == 'Coordinador y Aplicación' || status_user =='Solo Coordinador'">
                <v-text-field
                v-model="form.name"
                :counter="10"
                :rules="nameRules"
                label="Nombre"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.email"
                :counter="10"
                :rules="emailRules"
                label="Correo"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.password"
                :counter="10"
                :rules="passwordRules"
                label="Clave"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.password_confirmation"
                :counter="10"
                :rules="passwordRules"
                label="Repite la clave"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                required
              ></v-text-field>


            <v-btn
                :disabled="!form.name||!form.password||!form.email"
                color="primary"
                class="mr-4"
                @click="subirUsuario" 
              >
                Generar
              </v-btn>
          </div>






          <div v-if="status_user == 'Solo Aplicación'">
                <v-select
                  v-if="user.type == 'administrador'"
                  label="Cuenta de aplicacion bajo supervicion de"
                  :items="supervisor"
                  v-model="form.supervisor"
                ></v-select>
                
              <v-text-field
                v-model="form.name"
                :counter="10"
                :rules="nameRules"
                label="Nombre"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.email"
                :counter="10"
                :rules="nameRules"
                label="Nombre de usuario"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.password"
                :counter="10"
                :rules="passwordRules"
                label="Clave"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                required
              ></v-text-field>

              <v-text-field
                v-model="form.password_confirmation"
                :counter="10"
                :rules="passwordRules"
                label="Repite la clave"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                required
              ></v-text-field>


            <v-btn
                :disabled="!form.name||!form.password||!form.email"
                color="primary"
                class="mr-4"
                @click="subirUsuario" 
              >
                Generar
              </v-btn>
          </div>


          

    
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
     
      
    </v-row>
</template>
<script>

import {register, registerApp} from '../../../../../../services/auth/authenticate'

export default {
    
    mounted() {
      this.comprobacion()
    

    },

    data() {
        return {
            form:{
                name:'',
                password:'',
                password_confirmation:'',
                email:'',
                ////

                supervisor:''
            },
            show2: false,
            show1: false,

            typeuser:[
              'Coordinador y Aplicación',
              'Solo Coordinador',
              'Solo Aplicación'
            ],


            status_user:'Coordinador y Aplicación',
            status_coordinador:'Solo Aplicación',

            nameRules: [
                v => !!v || 'Nombre es requerido',
                v => (v && v.length <= 30) || 'El Nombre es inválido',
            ],
      
            emailRules: [
            v => !!v || 'Correo es requerido',
            v => /.+@.+\..+/.test(v) || 'El correo es inválido',
            ],

            passwordRules: [
            v => !!v || 'Clave es requerido',
            v => (v && v.length <= 10) || 'la clave proporcionada es inválida',
            ],


        }
    },     

    computed: {
      supervisor(){
        return this.$store.getters.select_responsable_app
      },


      user(){
        return this.$store.state.currentUser.user;
      }

    },
    
    methods: {
        comprobacion:function(){
            if (this.user.type == 'supervisor') {
              this.status_user = 'Solo Aplicación';
              this.form.supervisor = this.user.name; 
            }else{
              this.status_user = 'Coordinador y Aplicación';
            }
            
        },

        subirUsuario:function(){
            if (this.status_user == 'Coordinador y Aplicación' || this.status_user == 'Solo Coordinador') {
                  
                  var data = new FormData;
                  data.append('type', this.status_user);
                  data.append('name', this.form.name);
                  data.append('password', this.form.password);
                  data.append('email', this.form.email);
                  data.append('password_confirmation', this.form.password_confirmation);
                  
                  
                  this.$store.dispatch('LoadingFetchActions', true);
                    register(data).then(response=>{
                        console.log(response);
                        this.$store.dispatch('GetUserSupervisorActions');
                        this.$store.dispatch('GetUserAppActions');
                        this.$toastr.success('Se ha agregado un nuevo usuario');
                        this.$store.dispatch('LoadingFetchActions', false);
                        this.vaciarcampos();
                    }).catch(errors=>{
                        console.log(errors);
                        this.$store.dispatch('LoadingFetchActions', false);
                    }); 
              }else{
                    
                var data = new FormData;
                  data.append('type', this.status_user);
                  data.append('supervisor', this.form.supervisor);
                  data.append('name', this.form.name);
                  data.append('password', this.form.password);
                  data.append('username', this.form.email);
                  data.append('password_confirmation', this.form.password_confirmation);
                  
                  
                  this.$store.dispatch('LoadingFetchActions', true);
                    registerApp(data).then(response=>{
                        console.log(response);
                        this.$store.dispatch('GetUserSupervisorActions');
                        this.$store.dispatch('GetUserAppActions');
                        this.$toastr.success('Se ha agregado un nuevo usuario para la aplicacion');
                        this.$store.dispatch('LoadingFetchActions', false);
                        this.vaciarcampos();
                    }).catch(errors=>{
                        console.log(errors);
                        this.$store.dispatch('LoadingFetchActions', false);
                    }); 

              }
            }
            
    },

    vaciarcampos:function(){

        this.name = '';
        this.password = '';
        this.password_confirmation = '';
        this.email = '';

    }

}
</script>